
              const Handlebars = require('handlebars');
              const templateFunction = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  return "<span>\n    For example <a href=\"/#services/results/Aboriginal Health/Grafton\">Keywords: \"Aboriginal Health\" &amp; Location: \"Grafton\"</a>.\n    You can also search for just a location by entering the postcode. For example\n    <a href=\"/#services/servicetypes/3066\">3066</a>.\n</span>\n";
  },"useData":true});
              Handlebars.templates['src/hbs/partials/text_below_search_input.hbs'] = templateFunction;
              export default templateFunction;
              